'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import clsx from 'clsx';
import { forwardRef, useEffect, useState } from 'react';
import { HeaderBar } from './HeaderBar';
import { headerCssClassNames } from './headerCssClassNames';
import { HeaderStateContext } from './HeaderStateContext';
export const Header = forwardRef(({ children, onScreenSizeChange, className, HeaderBarProps, ...props }, ref) => {
    const theme = useTheme();
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('xs'));
    const isMobile = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isLaptop = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const isDesktop = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
    const isWideScreen = useMediaQuery(theme.breakpoints.up('xl'));
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(Boolean(props.isMobileMenuOpen));
    const handleMobileMenuClick = (event) => {
        if (props.onMobileMenuClick) {
            props.onMobileMenuClick(event, isMobileMenuOpen);
        }
    };
    const handleMobileMenuOpen = () => {
        setIsMobileMenuOpen(true);
    };
    const handleMobileMenuClose = () => {
        setIsMobileMenuOpen(false);
    };
    useEffect(() => {
        onScreenSizeChange?.({
            isSmallMobile,
            isMobile,
            isTablet,
            isLaptop,
            isDesktop,
            isWideScreen
        });
    }, [isSmallMobile, isMobile, isTablet, isLaptop, isDesktop, isWideScreen, onScreenSizeChange]);
    return (_jsx(HeaderStateContext.Provider, { value: {
            // CurrentSizes
            isSmallMobile: props.isSmallMobile || isSmallMobile,
            isMobile: props.isMobile || isMobile,
            isTablet: props.isTablet || isTablet,
            isLaptop: props.isLaptop || isLaptop,
            isDesktop: props.isDesktop || isDesktop,
            isWideScreen: props.isWideScreen || isWideScreen,
            // HeaderEventHandlers
            handleMobileMenuClick,
            handleMobileMenuOpen,
            handleMobileMenuClose,
            onScreenSizeChange,
            ...props, // TODO: avoid overwriting props like this
            isMobileMenuOpen
        }, children: _jsx(HeaderBar, { ...HeaderBarProps, className: clsx(className, headerCssClassNames.root), ref: ref, children: children }) }));
});
Header.defaultProps = {
    logoLink: '/',
    logoLinkText: 'Go to home',
    variant: 'default',
    hideMobileMenu: false,
    showSearch: false,
    hideBranding: false,
    hideNavigation: false,
    isContained: false,
    isMobileMenuOpen: false,
    isSticky: false,
    mobileMenuPosition: 'right',
    navigationPosition: 'top',
    navigationItems: []
};
Header.displayName = 'Header';
